import { apiWrapper } from "@/services/api";

export const postTransferKey = async (id) => {
  try {
    return await apiWrapper("POST", `books/${id}/transfer_key`);
  } catch (err) {
    console.log('ERROR"" postTransferKey()');
    throw err;
  }
};
